import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VentaService } from 'src/app/services/venta.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styles: [
  ]
})
export class HomeComponent implements OnInit {

  id = 'paso';

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              public service: VentaService) { }

  ngOnInit(): void {

    this.activatedRoute.params.subscribe( params => {
      if (params['id'] === this.id) {
        this.service.openPage = true;
        this.router.navigateByUrl('/login');
      }
    });
  }

}
